import {
  getContextOutcomesUrl,
  getContextsUrl,
  getCoursesUrl,
  getQualityMetricsUrl,
} from "../config/Config";
import { getRequest, putRequest } from "./ServiceHelper";

export class CourseService {
  static approveAllOutcomes = (
    ownerCourseCode,
    courseLevels,
    taxonomyLevels,
    verb_count,
    outcome_length,
    classification
  ) => {
    const params = {};

    if (ownerCourseCode) {
      params.ownerCourseCode = ownerCourseCode;
    }
    if (!!courseLevels && courseLevels.length > 0) {
      params.courseLevels = courseLevels;
    }
    if (!!taxonomyLevels && taxonomyLevels.length > 0) {
      params.taxonomyLevels = taxonomyLevels;
    }
    if (verb_count) {
      params.verb = verb_count;
    }
    if (outcome_length) {
      params.outcome = outcome_length;
    }

    params.classification = classification;

    return getRequest(getCoursesUrl() + "/" + "classify", params);
  };

  static getCourses = (
    {
      ownerCourseCode,
      programIds,
      courseGroupIds,
      courseIds,
      courseLevels,
      taxonomyLevels,
      page,
      pageSize,
      qc,
      approval,
      verb_count,
      outcome_length,
      withOutcomes,
      creationMethod,
      currentOutcomesOnly,
      includeFutureOutcomes,
    },
    signal
  ) => {
    const params = {};
    if (ownerCourseCode && ownerCourseCode.length > 0) {
      if (typeof ownerCourseCode === Array) {
        ownerCourseCode = ownerCourseCode.toString();
      }
      params.ownerCourseCode = ownerCourseCode;
    }
    if (programIds?.length) {
      params.programIds = programIds;
    }
    if (courseGroupIds?.length) {
      params.courseGroupIds = courseGroupIds;
    }
    if (courseIds?.length) {
      params.courseIds = courseIds;
    }
    if (courseLevels?.length) {
      params.courseLevels = courseLevels;
    }
    if (taxonomyLevels?.length) {
      params.taxonomyLevels = taxonomyLevels;
    }
    if (page) {
      params.page = page;
    }
    if (pageSize) {
      params.pageSize = pageSize;
    }
    if (qc) {
      params.qc = qc;
    }
    if (approval) {
      params.approval = approval;
    } else {
      params.approval = "approved";
    }
    if (verb_count) {
      params.verb = verb_count;
    }
    if (outcome_length) {
      params.outcome = outcome_length;
    }
    if (!withOutcomes) {
      params.withOutcomes = false;
    }
    if (currentOutcomesOnly) {
      params.currentOutcomesOnly = true;
    }
    if (creationMethod) {
      params.creationMethod = creationMethod;
    }
    if (includeFutureOutcomes) {
      params.includeFutureOutcomes = true;
    }
    return getRequest(getCoursesUrl(), params, false, signal);
  };

  static getContextOutcomes = (
    courseId,
    qc,
    userId = null,
    enrichRatings = false,
    unapprovedContextId = null,
    signal = null
  ) => {
    const params = {};
    if (qc) {
      params.qc = qc;
    }
    if (userId) {
      params.userId = userId;
    }
    if (enrichRatings) {
      params.enrichRatings = true;
    }
    if (unapprovedContextId) {
      params.unapprovedContextId = unapprovedContextId;
    }
    return getRequest(getContextOutcomesUrl(courseId), params, false, signal);
  };

  static getCoursesByFacultyId = (facultyId, qc) => {
    const params = {};
    if (qc) {
      params.qc = qc;
    }
    return getRequest(getCoursesUrl() + "/faculty/" + facultyId, params);
  };

  static getCourseByCanvasId = (canvasId) => {
    return getRequest(getCoursesUrl() + "/" + canvasId);
  };

  static getQualityMetrics = (ownerCourseCode, signal) => {
    const params = {};
    if (ownerCourseCode) {
      params.ownerCourseCode = ownerCourseCode;
    }
    return getRequest(getQualityMetricsUrl(), params, false, signal);
  };

  static upsertContext = (
    name,
    code,
    departmentTitle,
    levelId = null,
    id = null
  ) => {
    const payload = {
      name: name,
      code: code ? code : name,
      academic_subject: departmentTitle,
      level: levelId,
      id: id,
    };
    return putRequest(getContextsUrl(), { context: payload });
  };

  static getContextForCourseCoordinatorAssignment = (facultyId) => {
    return getRequest(getCoursesUrl() + "/coordinator/" + facultyId);
  };
}
